var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"d-flex flex-column",style:({backgroundColor:'rgba(255,255,255,0.5)'}),attrs:{"height":"100%"}},[_c('v-card-title',{class:{ 'text-cation': !_vm.$mobileBreakpoint }},[_vm._t("title")],2),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }